// Static content data used across components

export const STATS = [
  { num: '500+', key: 'home.statsStudents' },
  { num: '25+',  key: 'home.statsEvents' },
  { num: '80+',  key: 'home.statsVolunteers' },
  { num: '1+',   key: 'home.statsYears' },
];

export const TEAM_MEMBERS = [
  { key: 'member1', initials: 'सु', avatarClass: 'team-avatar-1' },
  { key: 'member2', initials: 'उ',  avatarClass: 'team-avatar-2' },
  { key: 'member3', initials: 'ज्ञा',avatarClass: 'team-avatar-3' },
  { key: 'member4', initials: 'पां',avatarClass: 'team-avatar-4' },
  { key: 'member5', initials: 'सं', avatarClass: 'team-avatar-5' },
  { key: 'member6', initials: 'नि', avatarClass: 'team-avatar-6' },
];

export const ACTIVITIES = [
  { key: 'activity1', icon: 'bi-mic-fill',          iconClass: 'card-icon-primary'   },
  { key: 'activity2', icon: 'bi-bank2',              iconClass: 'card-icon-secondary' },
  { key: 'activity3', icon: 'bi-music-note-beamed',  iconClass: 'card-icon-accent'    },
  { key: 'activity4', icon: 'bi-journal-text',       iconClass: 'card-icon-purple'    },
  { key: 'activity5', icon: 'bi-people-fill',        iconClass: 'card-icon-gold'      },
  { key: 'activity6', icon: 'bi-gender-female',      iconClass: 'card-icon-rose'      },
];

export const TALENTS = [
  { key: 'talent1', icon: 'bi-mic-fill',           talentIconClass: 'card-icon-primary'   },
  { key: 'talent2', icon: 'bi-music-note-beamed',  talentIconClass: 'card-icon-secondary' },
  { key: 'talent3', icon: 'bi-broadcast',          talentIconClass: 'card-icon-accent'    },
  { key: 'talent4', icon: 'bi-pencil-square',      talentIconClass: 'card-icon-purple'    },
  { key: 'talent5', icon: 'bi-book-half',          talentIconClass: 'card-icon-gold'      },
  { key: 'talent6', icon: 'bi-megaphone-fill',     talentIconClass: 'card-icon-rose'      },
];

export const HOBBIES = [
  { key: 'hobby1', icon: 'bi-flower1',           iconClass: 'card-icon-accent'    },
  { key: 'hobby2', icon: 'bi-paint-bucket',      iconClass: 'card-icon-secondary' },
  { key: 'hobby3', icon: 'bi-egg-fried',         iconClass: 'card-icon-gold'      },
  { key: 'hobby4', icon: 'bi-youtube',           iconClass: 'card-icon-rose'      },
  { key: 'hobby5', icon: 'bi-music-note-beamed', iconClass: 'card-icon-primary'   },
  { key: 'hobby6', icon: 'bi-music-player-fill', iconClass: 'card-icon-purple'    },
];

export const SPEECHES = [
  { key: 'speech1', icon: 'bi-flag-fill',               speechCardClass: 'speech-card'           },
  { key: 'speech2', icon: 'bi-shield-shaded',           speechCardClass: 'speech-card speech-card-secondary' },
  { key: 'speech3', icon: 'bi-balloon-heart-fill',      speechCardClass: 'speech-card speech-card-accent'    },
  { key: 'speech4', icon: 'bi-globe-asia-australia',    speechCardClass: 'speech-card speech-card-purple'    },
  { key: 'speech5', icon: 'bi-house-heart-fill',        speechCardClass: 'speech-card speech-card-gold'      },
];

export const WRITINGS = [
  { key: 'writing1', icon: 'bi-journal-richtext', cardClass: 'cf-card cf-card-accent-primary'   },
  { key: 'writing2', icon: 'bi-phone-fill',        cardClass: 'cf-card cf-card-accent-secondary' },
];

export const VALUES = [
  { key: '1', icon: 'bi-eye',           iconClass: 'card-icon-primary',   cardClass: 'value-card value-card-1' },
  { key: '2', icon: 'bi-stars',         iconClass: 'card-icon-secondary', cardClass: 'value-card value-card-2' },
  { key: '3', icon: 'bi-heart',         iconClass: 'card-icon-accent',    cardClass: 'value-card value-card-3' },
  { key: '4', icon: 'bi-shield-check',  iconClass: 'card-icon-purple',    cardClass: 'value-card value-card-4' },
];

export const GOALS = ['goal1', 'goal2', 'goal3', 'goal4', 'goal5', 'goal6'];

export const WAYS = [
  { key: 'way1', icon: 'bi-heart-fill',         iconClass: 'card-icon-primary'   },
  { key: 'way2', icon: 'bi-people-fill',        iconClass: 'card-icon-secondary' },
  { key: 'way3', icon: 'bi-share-fill',         iconClass: 'card-icon-accent'    },
  { key: 'way4', icon: 'bi-building',           iconClass: 'card-icon-purple'    },
  { key: 'way5', icon: 'bi-calendar-event-fill',iconClass: 'card-icon-gold'      },
  { key: 'way6', icon: 'bi-book-fill',          iconClass: 'card-icon-rose'      },
];

export const MEMORY_CARDS = [
  { key: 'memory1', icon: 'bi-music-note-beamed', cardClass: 'memory-card memory-card-1' },
  { key: 'memory2', icon: 'bi-broadcast',          cardClass: 'memory-card memory-card-2' },
  { key: 'memory3', icon: 'bi-building',           cardClass: 'memory-card memory-card-3' },
  { key: 'memory4', icon: 'bi-chat-quote',          cardClass: 'memory-card memory-card-4' },
  { key: 'memory5', icon: 'bi-book',               cardClass: 'memory-card memory-card-5' },
];

export const ASPIRATION_CELLS = [
  { key: 'aspirationCell1', icon: 'bi-mortarboard-fill', cellClass: 'aspiration-cell aspiration-cell-1', iconColor: 'text-brand' },
  { key: 'aspirationCell2', icon: 'bi-book-fill',        cellClass: 'aspiration-cell aspiration-cell-2', iconColor: 'text-accent' },
  { key: 'aspirationCell3', icon: 'bi-mic-fill',         cellClass: 'aspiration-cell aspiration-cell-3', iconColor: 'text-brand' },
  { key: 'aspirationCell4', icon: 'bi-heart-fill',       cellClass: 'aspiration-cell aspiration-cell-4', iconColor: 'text-brand' },
];
